import React, { useEffect } from 'react';

import { Box, Flex, HStack, Stack } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Card, PageHeaderWithIcon } from 'components/DataDisplay';
import { LearnMore } from 'components/DataDisplay/KnowledgeBase/Components/LearnMore';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { AddButton } from 'components/DataEntry';
import { LearnMoreButton } from 'components/DataEntry/Button/LearnMoreButton';
import { DataGroupIcon } from 'components/Icons';
import { selectApp } from 'containers/App/selectors';
import { DataAccessGettingStarted } from 'containers/Jit/Components/DataAccessGettingStarted';
import { getDataGroupsSensitivityQuery } from 'containers/Jit/Components/dataGroupSensitivityUtils';
import { DataGroupTable } from 'containers/Jit/DataGroups/Components/DataGroupTable';

import { selectDataGroups } from '../selectors';
import { actions } from '../slice';

interface Props {
  basePath?: string;
}

export const DataGroupComponent = ({ basePath = '/jit/data/group' }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLearnMore } = useKnowledgeBase();
  const { cloudAccounts } = useSelector(selectApp);
  const { dataGroups } = useSelector(selectDataGroups);
  const [hasStarted, setHasStarted] = React.useState(false);

  const [hasCheckedDataGroups, setHasCheckedDataGroups] = React.useState(false);

  useEffect(() => {
    dispatch(
      actions.getDataGroups({
        q: {
          page: dataGroups.page.info.page_number,
          size: dataGroups.page.info.page_size,
        },
        onSuccess: res => {
          // Sensitivity for every data group on the page comes from one bulk request.
          const q = getDataGroupsSensitivityQuery(
            (res?.items ?? []).map(dataGroup => dataGroup?.uuid),
          );
          if (!q.dataGroupSensitivityRequest.data_group_ids.length) return;
          dispatch(actions.getDataGroupsSensitivity({ q }));
        },
      }),
    );
  }, [
    dataGroups.page.info.page_number,
    dataGroups.page.info.page_size,
    dispatch,
  ]);

  useEffect(() => {
    dispatch(actions.getDataGroupRequestCounts({}));
  }, [dispatch]);

  useEffect(() => {
    if (dataGroups.isSuccess) setHasCheckedDataGroups(true);
  }, [dataGroups.isSuccess]);

  // const showGettingStarted =
  //   dataGroups.isSuccess && isEmpty(dataGroups.data) && !hasStarted;

  // if (showGettingStarted) {
  //   return (
  //     <Card styles={{ cardContent: { p: 0 } }}>
  //       <DataAccessGettingStarted onGetStarted={() => setHasStarted(true)} />
  //     </Card>
  //   );
  // }

  return (
    <Card>
      <Stack w="full" spacing={5}>
        <HStack justify="space-between" w="full">
          <PageHeaderWithIcon
            label="Data Groups"
            icon={<DataGroupIcon />}
            iconStyles={{ p: 1.5 }}
          />
          <Flex justify="flex-end">
            <HStack>
              <LearnMoreButton
                onOpen={() => setLearnMore('data_group')}
                label="Data Group"
              />
              <AddButton
                label="Add Data Group"
                onClick={() => navigate(`${basePath}/add`)}
              />
            </HStack>
          </Flex>
        </HStack>
        <Box flex={1}>
          <DataGroupTable />
        </Box>
      </Stack>
      <LearnMore />
    </Card>
  );
};
